<script lang="ts">
	import fnum, { type FinancialNumber } from 'shared/number'

	import { get_kydex_color_swatch_url } from 'shared/bzns/holster/image_paths'
	import { format_money_$_with_optional_cents } from 'shared/format_currency'
	import map_has from 'shared/map_has'
	import assert from 'shared/assert'

	const get_image_url = (color_file_name: string) => get_kydex_color_swatch_url({
		color_file_name,
		image_max_size,
		dpr: typeof window !== `undefined` ? window.devicePixelRatio : 2,
	})

	export let colors: TrexColor[]
	export let color_ref_to_additional_price: Map<number, FinancialNumber>
	export let promo_active: boolean
	export let promo_discount_rate: FinancialNumber

	export let selected: TrexColor | null = null
	export let image_min_size = 48
	export let image_max_size = 58

	const get_color_price = (color_ref: number) => {
		assert(map_has(color_ref_to_additional_price, color_ref))
		return fnum(color_ref_to_additional_price.get(color_ref)).times(fnum(`1`).minus(promo_active ? fnum(promo_discount_rate) : fnum(`0`)))
	}
</script>

<ul role=radiogroup style="--image-min-size: {image_min_size}px">
	{#each colors as color (color.color_ref)}
		{@const color_price = get_color_price(color.color_ref)}
		<li>
			<button
				role=radio
				aria-checked={selected === color}
				style="background-image: url({get_image_url(color.image_file_name_string)});"
				on:click={() => { selected = color }}
				title={color.name}
				aria-label={color.name}
			></button>
			{#if color.color_ref === 31}<!-- Tigerstripe -->
				<div class="highlight">LTD</div>
			{/if}
			{#if !color_price.equal(`0`)}
				<div class=additional_price data-negative="{color_price.lt(`0`)}">
					{color_price.lt(`0`) ? `-` : ``}{format_money_$_with_optional_cents(color_price.times(color_price.lt(`0`) ? `-1` : `1`))}
				</div>
			{/if}
		</li>
	{/each}
</ul>

<style>
	ul {
		list-style: none;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(var(--image-min-size), auto));
		grid-gap: 4px;
		font-size: 0; /* I don't know the name for this phenomenon, but browsers add strange spacing to empty buttons https://stackoverflow.com/a/43433025 */
		width: 100%;
	}

	li {
		cursor: pointer;
		position: relative;
		font-family: 'Protipo Narrow';
	}

	button {
		padding: 0;
		width: 100%;
		height: 0;
		padding-bottom: 100%;
		background-color: transparent;
	}

	button[aria-checked=true] {
		box-shadow: 0 0 0 2px var(--contrast-gray);
	}

	button:focus {
		box-shadow: 0 0 0 3px var(--trex-green);
	}

	.highlight, .additional_price {
		line-height: 1;
		padding: 4px;
		color: var(--contrast-text);
		border-bottom-right-radius: 3px;
		border-top-left-radius: 3px;
		letter-spacing: initial;
		pointer-events: none;
		white-space: nowrap;
		position: absolute;
		font-variant-numeric: tabular-nums;
	}

	.highlight {
		font-size: 10px;
		text-transform: uppercase;
		background: var(--flaregun-red);
		left: 0;
		top: 0;
	}

	.additional_price {
		font-size: 14px;
		background-color: #00000070;
		right: 0;
		bottom: 0;
	}

	.additional_price[data-negative=true] {
		background: var(--flaregun-red);
	}
</style>
